<template>
  <v-layout>
    <v-tabs background-color="white" color="primary" right>
      <v-tab v-for="tab in tabs" :key="tab">{{$t('json.' + tab)}}</v-tab>
      <v-tab-item v-for="n in tabs" :key="n" :transition="false" :reverse-transition="false">
        <v-container v-if="n === 'urlgenerator'" fluid>
          <RequestParams :props="BatchSettings" :disable="DisableSettings" @changeSettings="changeSettings" :preview="true"></RequestParams>
          <BatchProperties :props="BatchSettings" :disable="DisableSettings" @changeSettings="changeSettings" :preview="true"></BatchProperties>
          <ClassSettings :props="BatchSettings" :disable="DisableSettings" @changeSettings="changeSettings" :preview="true"></ClassSettings>
          <IndexSettings :props="BatchSettings" :disable="DisableSettings" @changeSettings="changeSettings" :preview="true"></IndexSettings>
          <EndpointSettings @changeSettings="changeSettings" :disable="DisableSettings" :EndpointSettings="batchTypes.Current.EndpointSettings" :expanded="true" :preview="true"></EndpointSettings>
          <v-row align="center" justify="center">
            <v-col :cols="7">
            <ApplicationSettings :disable="DisableSettings" @changeSettings="changeSettings" :props="batchTypes" :preview="true"></ApplicationSettings>
            <ExportSettings :disable="DisableSettings" @changeSettings="changeSettings" :props="ApplicationSettings" :preview="true"></ExportSettings>
            <ImportSettings :disable="DisableSettings" @changeSettings="changeSettings" :props="ApplicationSettings" :preview="true"></ImportSettings>
            <ScanSettings :disable="DisableSettings" @changeSettings="changeSettings" :props="ApplicationSettings" :preview="true"></ScanSettings>
            </v-col>
          </v-row>
          <StatusBarSettings :props="BatchSettings" :disable="DisableSettings" @changeSettings="changeSettings" :preview="true"></StatusBarSettings>
          <v-row align="center" justify="center">
            <v-col :cols="1"></v-col>
            <v-col :cols="2" >
                <v-btn block @click="clickGenerate">{{$t('json.generate')}}</v-btn>
            </v-col>
            <v-col :cols="3">
              <v-switch v-model="Quick" :label="$t('json.quickscan')"></v-switch>
            </v-col>
          </v-row>
          <v-row align="center" justify="center">
            <v-col :cols="10" >
              <v-textarea outlined name="input-7-4" label="JSON URL" v-model="jsonHash" readonly></v-textarea>
            </v-col>
          </v-row>
        </v-container>
        <v-container v-if="n === 'batchsettings'">
          <RequestParams :props="BatchSettings" :disable="DisableSettings" @changeSettings="changeSettings"></RequestParams>
          <BatchProperties :props="BatchSettings" :disable="DisableSettings" @changeSettings="changeSettings"></BatchProperties>
          <ClassSettings :props="BatchSettings" :disable="DisableSettings" @changeSettings="changeSettings"></ClassSettings>
          <IndexSettings :props="BatchSettings" :disable="DisableSettings" @changeSettings="changeSettings"></IndexSettings>
          <EndpointSettings @changeSettings="changeSettings" :disable="DisableSettings" :EndpointSettings="batchTypes.Current.EndpointSettings" :expanded="true"></EndpointSettings>
          <StatusBarSettings :props="BatchSettings" :disable="DisableSettings" @changeSettings="changeSettings"></StatusBarSettings>
        </v-container>
        <v-container v-if="n === 'logs'" fluid>
          <v-select label="Select Log" :items="['Scan Log', 'Scan Log 32']" v-model="logType"></v-select>
          <v-textarea label="Logs" :row="70" full-width height="500px" :value="logValue" readonly></v-textarea>
        </v-container>
        <v-container v-if="n === 'about'" fluid>
          <v-row align="center" justify="center">
            <v-col :cols="2">{{$t('json.version')}}: {{version}} <br/><a :href="cclinetURL">{{$t('json.downloadc')}}</a><br></v-col>
          </v-row>
        </v-container>
        <v-container v-if="n === 'integrations'" fluid>
          <EndpointSettings :disable="false" @changeSettings="changeSettings" :EndpointSettings="EndpointSettings"></EndpointSettings>
          <SimEndpointSettings :disable="false" @changeSettings="changeSettings" :SimSettings="SimSettings"></SimEndpointSettings>
          <MFilesEndpointSettings :disable="false" @changeSettings="changeSettings" :EndpointMFiles="EndpointMFiles"></MFilesEndpointSettings>
          <MondayEndpointSettings :disable="false" @changeSettings="changeSettings" :EndpointMonday="EndpointMonday"></MondayEndpointSettings>
          <RequestParams :props="batchTypes.General" :disable="DisableSettings" @changeSettings="changeSettings"></RequestParams>
          <BatchProperties :props="batchTypes.General" :disable="DisableSettings" @changeSettings="changeSettings"></BatchProperties>
        </v-container>
        <v-container v-if="n === 'appsettingstab'" fluid>
          <v-row align="center" justify="center">
            <v-col :cols="7">
              <v-form ref="appSettForm">
                  <ApplicationSettings :disable="DisableSettings" @changeSettings="changeSettings" :props="batchTypes"></ApplicationSettings>
                  <ExportSettings :disable="DisableSettings" @changeSettings="changeSettings" :props="ApplicationSettings"></ExportSettings>
                  <ImportSettings :disable="DisableSettings" @changeSettings="changeSettings" :props="ApplicationSettings"></ImportSettings>
                  <ScanSettings :disable="DisableSettings" @changeSettings="changeSettings" :props="ApplicationSettings"></ScanSettings>
                  <ExtensionSettings :disable="DisableSettings" @changeExtensionSettings="changeExtensionSettings" :props="batchTypes"></ExtensionSettings>
              </v-form>
            </v-col>
          </v-row>
        </v-container>
        <v-container v-if="n === 'language'" fluid>
          <v-row align="center" justify="center">
            <v-col :cols="4">
              <v-label>{{ $t("json.langsettings") }}</v-label>
              <v-form ref="langForm">
                <v-select :items="languages" item-text="name" item-value="value" v-model="batchTypes.General.Lang" @change="changeLanguage"></v-select>
              </v-form>
            </v-col>
          </v-row>
        </v-container>
        <v-container v-if="n === 'mobilesettingstab'" fluid>
          <v-row align="center" justify="center">
              <br/><br/>
              <b>{{$t('json.mobilescansettings')}}</b>
          </v-row>
          <v-row  v-for="scan in MobileScanSettings" :key="scan.Id" align="center" justify="center">
              <v-col :cols="4">
                  <v-text-field v-model="scan.Value" :label="$t('json.link')" :rules="[() => !!scan.Value || $t('json.ruleempty')]" :ref="scan.Name" required readonly validate-on-blur></v-text-field>
              </v-col>
              <v-col :cols="2">
                  <v-text-field v-model="scan.Label" :label="$t('json.mobile_label')" readonly validate-on-blur></v-text-field>
              </v-col>
              <v-col :cols="1">
                  <v-btn icon @click="generateQrCode(scan.Value)"><v-icon>mdi-qrcode-scan</v-icon></v-btn>
              </v-col>
              <v-col :cols="1">
                  <v-btn icon @click="copyToClipBpard(scan)"><v-icon>mdi-clipboard-multiple-outline</v-icon></v-btn>
              </v-col>
              <v-col :cols="1">
                  <v-btn icon @click="removePropertyMobile(MobileScanSettings, scan)"><v-icon>mdi-server-remove</v-icon></v-btn>
              </v-col>
          </v-row>
          <v-row align="center" justify="center">
            <v-col :cols="3">
              <v-btn block @click="requestDialog">{{ $t('json.mobilerequestlink') }}</v-btn>
            </v-col>
          </v-row>
        </v-container>
        <v-container v-if="n === 'signupsimtab'" fluid>
          <v-row align="center" justify="center">
            <v-col :cols="4">
              <v-form ref="appSettForm">
                <SignupSIM :sim-settings="SimSettings"></SignupSIM>
              </v-form>
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>
    </v-tabs>
    <v-dialog v-model="QrCodeDialogOpen" max-width="600px">
      <v-card>
        <v-card-text>
          <v-img :src="qrCodeValue"></v-img>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" text @click="QrCodeDialogOpen = false">{{ $t('json.mobile_close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="RequestDialogOpen" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t("json.mobile_form_title") }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field :label="$t('json.mobile_label')" v-model="RequestDialogForm.Label" ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field :label="$t('json.mobile_autoExportFolder')" rows="10" @change="changeAutoExportFolder" v-model="RequestDialogForm.autoExportFolder"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea :label="$t('json.mobile_comment')" rows="10" v-model="RequestDialogForm.Comment"></v-textarea>
              </v-col>
              <v-col cols="12" v-show="requestDialogError">
                <p style="color: red;">
                  {{ requestDialogErrorMessage }}
                </p>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" text @click="RequestDialogOpen = false">{{ $t('json.mobile_close') }}</v-btn>
          <v-btn color="green darken-1" :loading="requestLoading" text @click="requestMobileScanLink">{{ $t('json.mobile_save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>

import Models from '@/Models'
import JsonURL from 'json-url'
// import BatchListVue from './BatchList.vue'
import DataTypes from '../DataTypes'
import axios from 'axios'
import ExportSettings from '@/components/ExportSettings'
import ImportSettings from '@/components/ImportSettings'
import SignupSIM from '@/components/SignupSIM'
import ApplicationSettings from '@/components/ApplicationSettings'
import ExtensionSettings from '@/components/ExtensionSettings'
import ScanSettings from '@/components/ScanSettings'
import SimEndpointSettings from '@/components/SimEndpointSettings'
import MFilesEndpointSettings from '@/components/MFilesEndpointSettings'
import MondayEndpointSettings from '@/components/MondayEndpointSettings.vue'
// import ScanSettings from '@/components/ScanSettings'
import RequestParams from '@/components/batch/RequestParams'
import BatchProperties from '@/components/batch/BatchProperties.vue'
import IndexSettings from '@/components/batch/IndexSettings'
import StatusBarSettings from '@/components/batch/StatusBarSettings'
import ClassSettings from '@/components/batch/ClassSettings.vue'
import EndpointSettings from '@/components/EndpointSettings.vue'
import useMetaLicense from '@/MetaLicense'
import useSnackInfo from '../SnackInfo'
const QRCode = require('qrcode')

export default {
  name: 'JsonUrlGenerator',
  // old way need to be deleted
  // props: ['batchTypes', 'profil', 'log', 'appSett', 'simSett', 'endpointSett', 'mobileScanSett'],
  props: ['batchTypes', 'profil', 'log', 'mobileScanSett'],
  components: { ExportSettings, ImportSettings, ApplicationSettings, ScanSettings, SimEndpointSettings, MFilesEndpointSettings, SignupSIM, ExtensionSettings, RequestParams, BatchProperties, IndexSettings, StatusBarSettings, ClassSettings, EndpointSettings, MondayEndpointSettings },
  data () {
    return {
      Quick: false,
      requestLoading: false,
      activeTab: 'appsettingstab',
      tabs: ['urlgenerator', 'batchsettings', 'integrations', 'appsettingstab', 'mobilesettingstab', 'logs', 'about', 'language'],
      // tabs: ['urlgenerator', 'batchsettings', 'integrations', 'appsettingstab', 'mobilesettingstab', 'signupsimtab', 'logs', 'about', 'language'],
      QrCodeDialogOpen: false,
      qrCodeValue: '',
      typeHelper: new DataTypes(),
      logType: 'Scan Log',
      languages: [{ name: 'English', value: 'en' }, { name: 'Slovenian', value: 'si' }, { name: 'Croatian', value: 'hr' }, { name: 'Serbian', value: 'sr' }, { name: 'Montenegrin', value: 'me' }, { name: 'Turkish', value: 'tr' }, { name: 'Hebrew', value: 'heb' }],
      jsonHash: '',
      MobileScanSettings: [],
      RequestDialogOpen: false,
      requestDialogError: false,
      requestDialogErrorMessage: '',
      RequestDialogForm: {
        name: '',
        Label: '',
        Value: '',
        Comment: '',
        autoExportFolder: ''
      }
    }
  },
  computed: {
    DisableSettings () {
      return this.batchTypes.BatchTypeJSON !== null
    },
    BatchSettings () {
      return this.batchTypes.Current.BatchSettings
    },
    ApplicationSettings () {
      // console.log(this.batchTypes)
      return this.batchTypes.Current.ApplicationSettings
    },
    EndpointSettings () {
      // console.log(this.batchTypes)
      return this.batchTypes.General.EndpointSettings
    },
    SimSettings () {
      // console.log(this.batchTypes)
      return this.batchTypes.General.SimSettings
    },
    EndpointMFiles () {
      // console.log(this.batchTypes)
      return this.batchTypes.General.EndpointMFiles
    },
    EndpointMonday () {
      // console.log(this.batchTypes)
      return this.batchTypes.General.EndpointMonday
    },
    LanguageSettings () {
      // console.log(this.batchTypes)
      return this.batchTypes.Current.LanguageSettings
    },
    logValue () {
      if (this.log === null || this.log === undefined) {
        return ''
      }
      const logs = this.log.split('{###32###}')
      if (this.logType === 'Scan Log') return logs[0]
      return logs[1]
    },
    version () {
      return window.Config.VERSION
    },
    appSettingsType () {
      return Models.AppSettingsTypes
    },
    appSettingsTypeObj () {
      const arr = []
      for (let i = 0; i < Models.AppSettingsTypesObj.length; ++i) {
        const type = Models.AppSettingsTypesObj[i]
        console.log('TYPEEEEE', type)
        type.name = this.$i18n.t('json.' + type.name)
        arr.push(type)
      }
      return arr
    },
    appEndpointSettingsType () {
      return Models.AppEndpointSettingsTypes
    },
    docIndexTypes () {
      return Models.DocIndexDataTypes
    },
    cclinetURL () {
      return window.Config.CCLIENT
    }
  },
  methods: {
    changeSettings (sett) {
      this.$emit('saveBatchType')
    },
    changeExtensionSettings (sett) {
      this.$emit('saveBatchTypeExtension', sett)
    },
    async changeAutoExportFolder (str) {
      str = str.trim()
      if (!str) str = ''
    },
    async generateQrCode (val) {
      const qrcoderesult = await QRCode.toDataURL(val)
      this.qrCodeValue = qrcoderesult
      this.QrCodeDialogOpen = true
    },
    copyToClipBpard (p) {
      const textToCopy = this.$refs[p.Name][0].$el.querySelector('input')
      textToCopy.select()
      window.document.execCommand('copy')
    },
    async requestDialog () {
      if (!useMetaLicense.Unlocked && this.MobileScanSettings.length >= useMetaLicense.MobileScan) {
        useSnackInfo.info(this.$i18n.t('licenselimitexc'))
        return
      }
      this.RequestDialogOpen = true
    },
    async requestMobileScanLink () {
      try {
        console.log('request LINK')
        this.requestLoading = true
        this.requestDialogError = false
        console.log(JSON.stringify(this.RequestDialogForm))
        const loc = new URL(window.location.href)
        let hostname = ''
        hostname = loc.hostname
        const hostnames = hostname.split('.')
        if (hostnames.length >= 2) {
          hostname = hostnames[hostnames.length - 2] + '.' + hostnames[hostnames.length - 1]
        } else {
          hostname = hostnames[hostnames.length - 1]
        }
        // FOR TEST PURPOSE
        hostname = 'solumainvoicereader.com'
        const response = await axios.post('https://mobilescan.' + hostname + ':3040/api/request/link?exportFolder=' + this.RequestDialogForm.autoExportFolder, this.RequestDialogForm)
        console.log('RESPONSE', response)
        const link = response.data
        const linkParam = { Name: 'Link' + Math.floor(Math.random() * 10000000), Value: link, Label: this.RequestDialogForm.Label, Comment: this.RequestDialogForm.Comment }
        this.RequestDialogForm.Label = ''
        this.RequestDialogForm.Comment = ''
        this.MobileScanSettings.push(linkParam)
        this.$emit('saveMobileScanSettings', this.MobileScanSettings)
        this.RequestDialogOpen = false
      } catch (err) {
        console.log(err.response, err)
        this.requestDialogError = true
        if (err.response !== undefined && err.response.status === 500) {
          this.requestDialogErrorMessage = err.response.data.message
        } else {
          this.requestDialogErrorMessage = err.toString()
        }
      } finally {
        this.requestLoading = false
      }
    },
    changeLanguage () {
      this.$emit('changeLanguage', this.batchTypes.General.Lang)
      this.changeSettings()
    },
    getId () {
      return Math.floor(Math.random() * 1000000)
    },
    removeProperty (arr, p) {
      const index = arr.indexOf(p)
      if (index > -1) arr.splice(index, 1)
    },
    removePropertyMobile (arr, p) {
      const index = arr.indexOf(p)
      if (index > -1) arr.splice(index, 1)
      // this.changeSettings()
      this.$emit('saveMobileScanSettings', this.MobileScanSettings)
    },
    clickGenerate (ev) {
      console.log('click generate json url')
      // if (!this.$refs.paramForm[0].validate()) return
      const codec = JsonURL('lzma')
      const strModel = JSON.stringify(this.batchTypes.Current)
      const model = JSON.parse(strModel)
      model.BatchSettings.Quick = this.Quick
      console.log(model)
      codec.compress(model).then((result) => {
        var loc = new URL(window.location.href)
        this.jsonHash = loc.protocol + '//' + loc.host + '/?p=' + result
      })
    }
  },
  created () {
    console.log('created json url')
    console.log('BATCH TYPES', this.batchTypes)
    this.typeHelper = new DataTypes()
    this.mobileScanSett.forEach(ms => this.MobileScanSettings.push(ms))
  }
}
</script>
